<template>
  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">

      <v-flex class="mb-3 mx-2">
        <m-pay-merchant-limited-view
          :merchant="merchant"
        />
      </v-flex>

      <v-flex v-if="true" class="mb-3 mx-2">
        <m-pay-merchant-limited-editor
          :merchant="merchant"
          :loading="loading"
          @submit="updateMerchant"
        />
      </v-flex>

      <v-flex class="mb-3 mx-2">
        <v-divider></v-divider>
        <m-pay-merchant-order-verification-url-editor
          :merchant="merchant"
          :loading="loading_order"
          :publicIp="publicIp"
          @submit="updateMerchantOrderVerificationUrl"
        />
        <v-divider></v-divider>
        <m-pay-merchant-payment-notification-url-editor
          :merchant="merchant"
          :loading="loading_order"
          :publicIp="publicIp"
          @submit="updateMerchantPaymentNotificationUrl"
          @ping="pingPaymentNotificationUrl"
        />
        <v-divider></v-divider>
        <m-pay-merchant-delivery-cost-calculation-url-editor
          :merchant="merchant"
          :loading="loading_order"
          :publicIp="publicIp"
          @submit="updateMerchantDeliveryCostCalculationUrl"
        />
        <v-divider></v-divider>
      </v-flex>

    </v-layout>
  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayMerchantLimitedEditor from './MPayMerchantLimitedEditor';
import MPayMerchantLimitedView from './MPayMerchantLimitedView';
import MPayMerchantOrderVerificationUrlEditor from './MPayMerchantOrderVerificationUrlEditor';
import MPayMerchantPaymentNotificationUrlEditor from './MPayMerchantPaymentNotificationUrlEditor';
import MPayMerchantDeliveryCostCalculationUrlEditor from './MPayMerchantDeliveryCostCalculationUrlEditor';

export default {
  name: 'MPayMerchantLimitedPage',
  components: {
    MPayMerchantLimitedEditor,
    MPayMerchantLimitedView,
    MPayMerchantOrderVerificationUrlEditor,
    MPayMerchantPaymentNotificationUrlEditor,
    MPayMerchantDeliveryCostCalculationUrlEditor,
  },
  data: () => ({
    loading: false,
    loading_order: false,
    merchant: {},
    publicIp: '',
  }),
  methods: {
    fetchMerchant() {
      this.loading = true;
      axios.get(queries.userMerchant())
        .then((response) => {
          this.merchant = response.data;
          this.merchant.country = response.data.country.name;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    fetchPublicIp() {
      axios.get(queries.serviceProviderPublicIp())
        .then((response) => {
          this.publicIp = response.data;
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    updateMerchant(merchant) {
      this.loading = true;
      axios.put(queries.userMerchant(), merchant)
        .then(() => {
          this.showSuccessMessage('Merchant updated successfully');
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    updateMerchantOrderVerificationUrl(merchant) {
      this.loading_order = true;
      axios.put(queries.userMerchantOrderVerificationUrl(), merchant)
        .then(() => {
          this.showSuccessMessage('Merchant Order Verification URL updated successfully');
          this.loading_order = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading_order = false;
        });
    },
    updateMerchantPaymentNotificationUrl(merchant) {
      this.loading_order = true;
      axios.put(queries.userMerchantPaymentNotificationUrl(), merchant)
        .then(() => {
          this.showSuccessMessage('Merchant Payment Notification URL updated successfully');
          this.loading_order = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading_order = false;
        });
    },
    updateMerchantDeliveryCostCalculationUrl(merchant) {
      this.loading_order = true;
      axios.put(queries.userMerchantDeliveryCostCalculationUrl(), merchant)
        .then(() => {
          this.showSuccessMessage('Merchant Shipping Cost Calculation URL updated successfully');
          this.loading_order = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading_order = false;
        });
    },
    pingPaymentNotificationUrl(merchant) {
      this.loading = true;
      axios.post(queries.userMerchantPaymentNotificationUrl(), merchant)
        .then(() => {
          this.showSuccessMessage('Merchant Payment Notification URL is accessible');
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
  },
  created() {
    this.fetchMerchant();
    this.fetchPublicIp();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantLimitedPage.vue